import { useEffect, useState } from 'react'
import { apiClient } from '@indipia/shared'

/**
 * 현장보고 사진 썸네일 로더 — url은 인증토큰이 필요한 게이트웨이 경로라
 * <img src>로 직접 로드하지 않고 apiClient(Authorization 자동 첨부)로 blob을 받아
 * objectURL로 표시한다. 로드 실패/빈 URL이면 중립 배경 플레이스홀더를 유지한다.
 */
export function ThumbImg({ url, className, alt = '' }: { url: string | null | undefined; className?: string; alt?: string }) {
  const [src, setSrc] = useState<string | null>(null)

  useEffect(() => {
    if (!url) return
    // 서버 thumbUrl은 게이트웨이 기준 전체경로(/api/worklog/...)다.
    // apiClient.baseURL이 이미 `${API_BASE}/api`라 그대로 넘기면 /api가 중복된다 → 선행 /api 제거.
    const path = url.replace(/^\/api(?=\/)/, '')
    let objectUrl: string | null = null
    const controller = new AbortController()
    apiClient
      .get<Blob>(path, { responseType: 'blob', signal: controller.signal })
      .then(res => { objectUrl = URL.createObjectURL(res.data); setSrc(objectUrl) })
      .catch(() => { /* 실패 시 플레이스홀더 유지 */ })
    return () => {
      controller.abort()
      if (objectUrl) URL.revokeObjectURL(objectUrl)
      setSrc(null)
    }
  }, [url])

  return (
    <div className={className} style={{ background: 'var(--shell-skeleton)', overflow: 'hidden' }}>
      {src && <img src={src} alt={alt} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />}
    </div>
  )
}
